export const ACQUISITION_MODE_OPTIONS = [
  { value: "1", label: "25 Hz Regular" },
  { value: "2", label: "25 Hz Raw" },
  { value: "3", label: "100 Hz Raw" },
];

// Yes/No settings. `name` is the backend key under acquisitionSettings.
export const APP_SETTINGS = [
  { name: "isEventButtonEnabled", label: "App event button enabled?" },
  { name: "isLivePlotsEnabled", label: "Show live plots in the App?" },
];
